(function () {
  if (window.SarvatiProductAddonsLoaded) return;
  window.SarvatiProductAddonsLoaded = true;

  const selectedClass = 'is-selected';

  function getAddonRoot(form) {
    return form && form.querySelector('[data-sarvati-addons]');
  }

  function getBundleRoot(form) {
    return form && form.querySelector('[data-sarvati-bundle]');
  }

  function getSelectedButtons(root) {
    if (!root) return [];
    return Array.from(root.querySelectorAll(`.sarvati-addons__button.${selectedClass}`));
  }

  function getSelectedBundleInputs(root) {
    if (!root) return [];
    return Array.from(root.querySelectorAll('.sarvati-bundle__checkbox:checked'));
  }

  // Sarvati fix 2026-07-13: show cart errors to the customer instead of only console
  function showCartError(form, error) {
    var msg = (error && (error.description || error.message)) || 'Sorry, this item could not be added to your cart. Please try again.';
    var note = form.querySelector('.sarvati-addons-cart-error');
    if (!note) {
      note = document.createElement('p');
      note.className = 'sarvati-addons-cart-error';
      note.setAttribute('role', 'alert');
      note.style.cssText = 'color:#b3261e;background:#fdecea;border:1px solid #f5c6c2;border-radius:6px;padding:10px 12px;font-size:13px;line-height:1.4;margin:10px 0 0;';
      var submitButton = form.querySelector('[type="submit"]');
      if (submitButton && submitButton.parentNode) {
        submitButton.parentNode.insertBefore(note, submitButton.nextSibling);
      } else {
        form.appendChild(note);
      }
    }
    note.textContent = msg;
    note.hidden = false;
  }

  function clearCartError(form) {
    var note = form.querySelector('.sarvati-addons-cart-error');
    if (note) note.hidden = true;
  }

  function syncSummary(root) {
    const selected = getSelectedButtons(root);
    const summary = root.querySelector('[data-sarvati-addons-summary]');
    const propertyInput = root.querySelector('[data-sarvati-addons-property]');
    const measurement = root.querySelector('[data-sarvati-addons-measurement]');
    const measurementLink = root.querySelector('[data-sarvati-addons-measurement-link]');
    const titles = selected.map((button) => button.dataset.addonTitle).filter(Boolean);
    const needsMeasurement = selected.some((button) => button.dataset.addonMeasurement === 'true');
    const selectedMeasurementUrl = selected
      .map((button) => button.dataset.addonMeasurementUrl)
      .find((url) => url && url.trim());

    if (propertyInput) {
      propertyInput.value = titles.join(', ');
    }

    if (measurement) {
      measurement.hidden = !needsMeasurement;
    }

    if (measurementLink) {
      if (needsMeasurement && selectedMeasurementUrl) {
        measurementLink.href = selectedMeasurementUrl;
        measurementLink.hidden = false;
      } else {
        measurementLink.href = '#';
        measurementLink.hidden = true;
      }
    }

    if (!summary) return;

    if (titles.length) {
      const prefix = root.dataset.sarvatiAddonsSummaryPrefix || 'Selected services';
      summary.hidden = false;
      summary.textContent = prefix ? `${prefix}: ${titles.join(', ')}` : titles.join(', ');
    } else {
      summary.hidden = true;
      summary.textContent = '';
    }
  }

  function initAddonRoot(root) {
    if (!root || root.dataset.sarvatiAddonsReady === 'true') return;
    root.dataset.sarvatiAddonsReady = 'true';

    root.addEventListener('click', (event) => {
      const measurementLink = event.target.closest('[data-sarvati-addons-measurement-link]');
      if (measurementLink) {
        return;
      }

      const button = event.target.closest('.sarvati-addons__button');
      if (!button) return;

      const group = button.dataset.addonGroup;
      if (group === 'blouse' || group === 'lehenga' || group === 'salwar') {
        root
          .querySelectorAll(`.sarvati-addons__button[data-addon-group="${group}"]`)
          .forEach((groupButton) => {
            if (groupButton !== button) groupButton.classList.remove(selectedClass);
          });
      }

      button.classList.toggle(selectedClass);
      syncSummary(root);
    });

    syncSummary(root);
    initGuide(root);
  }

  function initGuide(root) {
    const guide = root.querySelector('[data-sarvati-addons-guide]');
    const openButton = root.querySelector('[data-sarvati-addons-guide-open]');
    if (!guide || !openButton || guide.dataset.sarvatiGuideReady === 'true') return;
    guide.dataset.sarvatiGuideReady = 'true';

    const closeButtons = guide.querySelectorAll('[data-sarvati-addons-guide-close]');
    const tabs = guide.querySelectorAll('[data-sarvati-addons-guide-tab]');
    const panels = guide.querySelectorAll('[data-sarvati-addons-guide-panel]');

    function openGuide() {
      guide.hidden = false;
      document.documentElement.classList.add('sarvati-addons-guide-open');
      const activeTab = guide.querySelector('.sarvati-addons-guide__tab.is-active');
      if (activeTab) activeTab.focus({ preventScroll: true });
    }

    function closeGuide() {
      guide.hidden = true;
      document.documentElement.classList.remove('sarvati-addons-guide-open');
      openButton.focus({ preventScroll: true });
    }

    function showPanel(panelName) {
      tabs.forEach((tab) => {
        const active = tab.dataset.sarvatiAddonsGuideTab === panelName;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const active = panel.dataset.sarvatiAddonsGuidePanel === panelName;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    openButton.addEventListener('click', openGuide);

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeGuide);
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        showPanel(tab.dataset.sarvatiAddonsGuideTab);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !guide.hidden) {
        closeGuide();
      }
    });
  }

  function syncBundleSummary(root) {
    const selected = getSelectedBundleInputs(root);
    const summary = root.querySelector('[data-sarvati-bundle-summary]');
    const propertyInput = root.querySelector('[data-sarvati-bundle-property]');
    const titles = selected.map((input) => input.dataset.bundleTitle).filter(Boolean);

    root.querySelectorAll('.sarvati-bundle__item').forEach((item) => {
      const input = item.querySelector('.sarvati-bundle__checkbox');
      item.classList.toggle(selectedClass, Boolean(input && input.checked));
    });

    if (propertyInput) {
      propertyInput.value = titles.join(', ');
    }

    const totalEl = root.querySelector('[data-sarvati-bundle-total]');
    if (totalEl) {
      const sumCents = selected.reduce((s, i) => s + (parseInt(i.dataset.bundlePrice, 10) || 0), 0);
      const discountPct = parseFloat(root.dataset.bundleDiscount) || 0;
      if (!selected.length) {
        totalEl.hidden = true;
        totalEl.innerHTML = '';
      } else {
        const fmt = (c) => (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat)
          ? theme.Currency.formatMoney(c, theme.settings.moneyFormat)
          : ('₹' + Math.round(c / 100));
        totalEl.hidden = false;
        if (discountPct > 0) {
          const saveCents = Math.round((sumCents * discountPct) / 100);
          totalEl.innerHTML = '<span>Bundle total: ' + fmt(sumCents - saveCents) + '</span>'
            + '<span class="sarvati-bundle__save">You save ' + fmt(saveCents) + '</span>';
        } else {
          totalEl.innerHTML = '<span>Bundle total: ' + fmt(sumCents) + '</span>';
        }
      }
    }

    if (!summary) return;

    if (titles.length) {
      const prefix = root.dataset.sarvatiBundleSummaryPrefix || 'Bundle selected';
      summary.hidden = false;
      summary.textContent = prefix ? `${prefix}: ${titles.join(', ')}` : titles.join(', ');
    } else {
      summary.hidden = true;
      summary.textContent = '';
    }
  }

  function initBundleRoot(root) {
    if (!root || root.dataset.sarvatiBundleReady === 'true') return;
    root.dataset.sarvatiBundleReady = 'true';

    root.addEventListener('change', (event) => {
      if (!event.target.matches('.sarvati-bundle__checkbox')) return;
      syncBundleSummary(root);
    });

    syncBundleSummary(root);
  }

  function getItemsFromForm(form, root) {
    const formData = new FormData(form);
    const mainVariantId = Number(formData.get('id'));
    const quantity = Number(formData.get('quantity') || 1);
    const bundleRoot = getBundleRoot(form);
    const selectedAddons = getSelectedButtons(root);
    const selectedBundles = getSelectedBundleInputs(bundleRoot);
    const addonTitles = selectedAddons.map((button) => button.dataset.addonTitle).filter(Boolean);
    const bundleTitles = selectedBundles.map((input) => input.dataset.bundleTitle).filter(Boolean);

    const mainProperties = {};
    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value) {
        mainProperties[match[1]] = value;
      }
    }

    if (addonTitles.length) {
      mainProperties['Selected add-ons'] = addonTitles.join(', ');
    }

    // Sarvati 27 September 2026: every add-to-cart gets its own private group id
    // (underscore properties stay hidden in cart and checkout). The garment and
    // its add-on lines share it, so two configurations of the same product keep
    // their own stitching lines instead of being matched by product title.
    const group = 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    if (addonTitles.length || bundleTitles.length) mainProperties['_sv_group'] = group;

    if (bundleTitles.length) {
      mainProperties['Bundle selected'] = bundleTitles.join(', ');
    }

    const items = [
      {
        id: mainVariantId,
        quantity: quantity > 0 ? quantity : 1,
        properties: mainProperties,
      },
    ];

    selectedAddons.forEach((button) => {
      const addonVariantId = Number(button.dataset.addonVariantId);
      if (!addonVariantId) return;

      items.push({
        id: addonVariantId,
        quantity: 1,
        properties: {
          'Add-on for': form.dataset.productTitle || document.querySelector('[data-product-title]')?.dataset.productTitle || '',
          '_sv_group': group,
        },
      });
    });

    selectedBundles.forEach((input) => {
      const bundleVariantId = Number(input.dataset.bundleVariantId);
      if (!bundleVariantId) return;

      items.push({
        id: bundleVariantId,
        quantity: 1,
        properties: {
          'Bundle for': form.dataset.productTitle || document.querySelector('[data-product-title]')?.dataset.productTitle || '',
        },
      });
    });

    return items;
  }

  async function addItems(form, root) {
    const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const response = await fetch(`${rootUrl}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: getItemsFromForm(form, root) }),
    });

    const responseData = await response.json();
    if (!response.ok) throw responseData;
    return responseData;
  }

  function initSarvatiAddons() {
    document.querySelectorAll('[data-sarvati-addons]').forEach(initAddonRoot);
    document.querySelectorAll('[data-sarvati-bundle]').forEach(initBundleRoot);
  }

  document.addEventListener('DOMContentLoaded', initSarvatiAddons);

  // Re-init when product content is injected dynamically (Quick View, recommendations, AJAX collection).
  ['quickview:loaded', 'quickview:open', 'recommendations:loaded', 'collection:reloaded', 'page:loaded'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(initSarvatiAddons, 0); });
  });

  document.addEventListener('product-form:cart:request', async (event) => {
    const productForm = event.target.closest('product-form');
    const form = productForm && productForm.querySelector('form');
    const root = getAddonRoot(form);
    const bundleRoot = getBundleRoot(form);
    const hasSelectedAddons = getSelectedButtons(root).length > 0;
    const hasSelectedBundles = getSelectedBundleInputs(bundleRoot).length > 0;
    if (!form || (!hasSelectedAddons && !hasSelectedBundles)) return;

    event.preventDefault();

    try {
      const responseData = await addItems(form, root);
      clearCartError(form);
      event.detail.resolve(responseData);
    } catch (error) {
      showCartError(form, error);
      event.detail.reject(error);
    }
  });

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      const root = getAddonRoot(form);
      const bundleRoot = getBundleRoot(form);
      const hasSelectedAddons = getSelectedButtons(root).length > 0;
      const hasSelectedBundles = getSelectedBundleInputs(bundleRoot).length > 0;
      if (form.closest('product-form') || (!hasSelectedAddons && !hasSelectedBundles)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      try {
        await addItems(form, root);
        clearCartError(form);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      } catch (error) {
        console.error('Sarvati add-ons cart error:', error);
        showCartError(form, error);
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    },
    true
  );
})();
